











import Vue from 'vue'
import { ESortDir } from '@/constants/dataTable'

interface Methods {
  handleSort: () => void
}

interface Computed {
  columnClasses: string
  sortIconClass: string
}

interface Props {
  col: string
  label: string
  title?: string
  isSortable?: boolean
  sortBy?: ESortDir
}

export default Vue.extend<{}, Methods, Computed, Props>({
  props: {
    col: {
      required: true,
    },
    label: {
      required: true,
    },
    title: {
      default: () => '',
    },
    isSortable: {
      default: () => false,
    },
    sortBy: {
      default: () => undefined,
    },
  },

  computed: {
    columnClasses(): string {
      const classes = ` -${this.col}`
      if (this.isSortable) {
        return `${classes} -sortable`
      }
      return classes
    },
    sortIconClass(): string {
      switch (this.sortBy) {
        case ESortDir.ASC:
          return 'zmdi zmdi-long-arrow-down'
        case ESortDir.DESC:
          return 'zmdi zmdi-long-arrow-up'
        default:
          return 'zmdi zmdi-swap-vertical'
      }
    },
  },

  methods: {
    handleSort(): void {
      if (!this.isSortable) {
        return
      }

      this.$emit('sort', this.col)
    },
  },
})
